import { initDataLayer, isBrowser, persistTrackingData } from '../util';
export function pushMapPinClick(staticDetails) {
    if (!isBrowser())
        return;
    initDataLayer();
    const { name, geography, estabId, starRating } = staticDetails;
    const selectedHotelMapPin = {
        name,
        location: geography === null || geography === void 0 ? void 0 : geography.location,
        province: geography === null || geography === void 0 ? void 0 : geography.province,
        country: geography === null || geography === void 0 ? void 0 : geography.country,
        estabId,
        starRating,
    };
    window.dataLayer.push({ event: 'mapPinClick', selectedHotelMapPin });
    window.dataLayer.push({ event: 'hotelMapPopoverCardOpened' });
    persistTrackingData({ selectedHotelMapPin });
}
export function pushMapPopoverCard(staticDetails) {
    if (!isBrowser())
        return;
    initDataLayer();
    const { name, geography, estabId, starRating } = staticDetails;
    const selectedHotel = {
        name,
        location: geography === null || geography === void 0 ? void 0 : geography.location,
        province: geography === null || geography === void 0 ? void 0 : geography.province,
        country: geography === null || geography === void 0 ? void 0 : geography.country,
        estabId,
        starRating,
    };
    window.dataLayer.push({ event: 'mapPopoverCardClicked', selectedHotel });
    persistTrackingData({ selectedHotel });
}
export function pushMapPopoverCardClose() {
    if (!isBrowser())
        return;
    initDataLayer();
    window.dataLayer.push({ event: 'hotelMapPopoverCardClosed' });
}
